export default "__VITE_ASSET__D9ljmxXw__"